var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("Uygulama Erişim Ekranı")])]},proxy:true}])},[_c('vs-tabs',{attrs:{"alignment":"center"}},_vm._l((_vm.tabs),function(item,i){return _c('vs-tab',{key:i,attrs:{"label":item.name}},[_c('div',[_c(item.component,{tag:"component"})],1)])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }